import { render, staticRenderFns } from "./UserLoginHistory.vue?vue&type=template&id=1a604cca&scoped=true"
import script from "./UserLoginHistory.vue?vue&type=script&lang=js"
export * from "./UserLoginHistory.vue?vue&type=script&lang=js"
import style0 from "./UserLoginHistory.vue?vue&type=style&index=0&id=1a604cca&prod&lang=scss&scoped=true"
import style1 from "./UserLoginHistory.vue?vue&type=style&index=1&id=1a604cca&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a604cca",
  null
  
)

export default component.exports